import React from 'react';

export function CodeIcon() {
  // https://lucide.dev/icons/code
  return (
    <g stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="m16 18 6-6-6-6" />
      <path d="m8 6-6 6 6 6" />
    </g>
  );
}
